"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = manageYourTeam;
var _actionTypes = require("./actionTypes");
var _constants = require("./constants");
const initialState = {
  businessEntities: [],
  users: [],
  roles: [],
  mines: [],
  userActivityData: [],
  removeAccessSatus: false,
  sendInvitationState: false,
  usersList: [],
  inProgressAPICallCount: 0,
  pendingAccessRequests: [],
  showNotification: false,
  notificationType: '',
  notificationTitle: '',
  notificationMessage: '',
  callToActionList: [],
  onClose: () => {},
  mineSiteLabel: {
    singular: 'Mine Site',
    plural: 'Mine Sites'
  }
};
function manageYourTeam() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _actionTypes.ActionTypes.GET_BUSINESSENTITIES:
      {
        return {
          ...state,
          businessEntities: action.payload
        };
      }
    case _actionTypes.ActionTypes.GET_USER_DETAILS:
      {
        return {
          ...state,
          users: action.payload
        };
      }
    case _actionTypes.ActionTypes.GET_ROLES_FOR_APP:
      {
        return {
          ...state,
          roles: action.payload
        };
      }
    case _actionTypes.ActionTypes.GET_USERS_FOR_ROLE:
      {
        return {
          ...state,
          usersList: action.payload
        };
      }
    case _constants.CONSTANTS.SEND_INVITATION_STATE:
      return {
        ...state,
        sendInvitationState: action.sendInvitationState
      };
    case _actionTypes.ActionTypes.GET_MINESITES:
      {
        return {
          ...state,
          mines: action.payload
        };
      }
    case _actionTypes.ActionTypes.GET_USERACTIVITIES:
      {
        return {
          ...state,
          userActivityData: action.payload
        };
      }
    case _actionTypes.ActionTypes.SET_APP_ID:
      {
        return {
          ...state,
          appinfo: action.payload
        };
      }
    case _actionTypes.ActionTypes.SET_ASSIGNABLE_USERS:
      {
        return {
          ...state,
          assignableUsers: action.payload
        };
      }
    case _actionTypes.ActionTypes.FETCH_MINE_SITE_INFO_SUCCESS:
      {
        return {
          ...state,
          mineSiteInfo: action.response
        };
      }
    case _actionTypes.ActionTypes.UPDATE_API_CALL_PROGRESS:
      {
        return {
          ...state,
          inProgressAPICallCount: action.payload
        };
      }
    case _actionTypes.ActionTypes.SAVE_PENDING_ACCESS_REQUESTS:
      return {
        ...state,
        pendingAccessRequests: action.payload
      };
    case _actionTypes.ActionTypes.SAVE_ACCESS_REQUEST_ROLES:
      {
        return {
          ...state,
          accessRequestRoles: {
            ...state.accessRequestRoles,
            ...action.payload
          }
        };
      }
    case _actionTypes.ActionTypes.HIDE_NOTIFICATION:
      {
        return {
          ...state,
          showNotification: false,
          notificationType: '',
          notificationTitle: '',
          notificationMessage: '',
          callToActionList: [],
          onClose: () => {}
        };
      }
    case _actionTypes.ActionTypes.SHOW_NOTIFICATION:
      {
        return {
          ...state,
          showNotification: true,
          callToActionList: action.payload.callToActionList ? action.payload.callToActionList : [],
          onClose: action.payload.onClose ? action.payload.onClose : () => {},
          ...action.payload
        };
      }
    case _actionTypes.ActionTypes.SAVE_APPLICATION_BUSINESS_ENTITIES:
      {
        return {
          ...state,
          applicationBusinessEntities: {
            ...state.applicationBusinessEntities,
            ...action.payload
          }
        };
      }
    case _actionTypes.ActionTypes.SAVE_MINE_SITE_LABEL:
      {
        return {
          ...state,
          mineSiteLabel: action.payload
        };
      }
    default:
      return state;
  }
}